import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/app-version',
  component: Layout,
  name: 'appVersionManagement',
  meta: {
    title: 'APP版本管理',
    icon: 'i-ep:UploadFilled',
    menu: false,
  },
  children: [
    {
      path: '',
      name: 'appVersion',
      component: () => import('@/views/system/app-version/index.vue'),
      meta: {
        title: '版本列表',
        icon: 'i-ep:UploadFilled',
      },
    },
  ],
}

export default routes
